import { Checkbox, FormControlLabel } from '@material-ui/core';
import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { black, brand, white } from 'variables/colors';
import { fontWeightBold } from 'variables/font';
import { border, borderRadius } from 'variables/general';

const Component = styled.div`
  padding-left: 0.75em;
  border: ${({ checked }) => (checked ? `1px solid ${brand}` : border)};
  border-radius: ${borderRadius};

  .MuiTypography-root {
    color: ${({ checked }) => (checked ? brand : black)};
    font-weight: ${fontWeightBold};
    font-size: 0.75em;
  }
`;

const SelectButton = ({ disabled, label, handleToggleStaff, checked }) => {
  const handleChange = () => {
    handleToggleStaff();
  };

  return (
    <Component checked={checked}>
      <FormControlLabel
        control={
          <Checkbox
            color="primary"
            checked={checked}
            onChange={handleChange}
            name="selectStaff"
            size="small"
            disabled={disabled}
          />
        }
        label={checked ? 'Selected' : 'Select'}
      />
      {label}
    </Component>
  );
};

export default SelectButton;
